/**
 * @module UI/Constants
 */

/**
 * @readonly
 * @type {string}
 */
export const VISIBILITY_HIDDEN = 'hidden';

/**
 * @readonly
 * @type {string}
 */
export const VISIBILITY_VISIBLE = 'visible';

/**
 * @readonly
 * @type {string}
 */
export const STATE_READY = 'ready';

/**
 * @readonly
 * @type {string}
 */
export const STATE_ERROR = 'visible';

/**
 * @readonly
 * @type {string}
 */
export const STATE_LOADING = 'loading';

/**
 * @readonly
 * @type {string}
 */
export const STATE_EMPTY = 'empty';

/**
 * @readonly
 * @type {string}
 */
export const STATE_PARTIAL = 'partial';

/**
 * @readonly
 * @type {string}
 */
export const DISPLAY_COLLAPSED = 'collapsed';

/**
 * @readonly
 * @type {string}
 */
export const DISPLAY_EXPANDED = 'expanded';



// WEBPACK FOOTER //
// ./src/main/javascript/UI/Constants.js